import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Menu, Icon, Button, Modal } from 'semantic-ui-react';

import { LoadingBar, InfiniteScroll } from 'components/Commons';

import cm from 'helpers/commons';
import scroll from 'helpers/scroll';
import toastr from 'helpers/toastr';

class ExcelStaffList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: [],
      heightIdx: 0,
      containerHeight: 620,
      isInfiniteLoading: false
    };
  }

  componentWillMount() {
    const { tableResult } = this.props;
    this.setState({
      elements: []
    });
    this.scrollEvent(tableResult);
  }

  componentDidMount() {
    const windowH = $(window).height();
    if (windowH > 900) {
      const stepH = $('.ui.steps').outerHeight();
      const regMethodH = $('.reg-method').outerHeight();
      const staffUploadH = $('.staff-upload').outerHeight();
      const titleH = $('.sub-title').outerHeight();
      const countH = $('.count-box').outerHeight();
      const bottomH = $('.bottom-btns').outerHeight();

      const listH = windowH - (stepH + regMethodH + staffUploadH + titleH + countH + bottomH + 180);

      // 측정 대상이 아직 DOM 에 없으면 listH 가 NaN 이 되어 react-infinite 가 예외를 던진다
      if (listH > 0) {
        this.setState({ containerHeight: listH });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { tableResult, activeStep } = nextProps.StaffExcelFn;
    if (tableResult && tableResult.response) {
      toastr('top-right', 'error', tableResult.response.data.message);
    } else if (activeStep === 2) {
      this.setState({
        elements: []
      });
      this.scrollEvent(tableResult, activeStep);
    }
  }

  scrollEvent = (list, activeStep) => {
    if (list && list.data) {
      const { user } = list.data;
      if (user && user.length > 0) {
        const elements = scroll.buildElements(0, 100, user, false, activeStep);

        this.setState({
          elements: this.buildElements(0, 100, elements, false, activeStep)
        });
      } else {
        this.setState({ elements: [] });
      }
    }
  };

  buildElements = (start, end, item, isChecked, activeStep) => {
    const elements = [];

    if (!item) {
      return elements;
    }

    for (let i = start; i < end; i++) {
      const temp = this.listItem(item[i], activeStep);
      if (temp) {
        elements.push(temp);
      }
    }
    return elements;
  };

  listItem = (item, step) => {
    if (item) {
      const { activeStep, method } = this.props.StaffExcelFn;
      if ((activeStep === 3 || activeStep === 4) && item.status.value === 'none') {
        return;
      }
      let result = null;

      const { value, cellName } = item.status;
      const colorRed = '#e20b44';

      let statusColor = 'black';
      let delStatusColor = 'black';
      let signIdColor = 'black';
      let nameColor = 'black';
      let orgCodeColor = 'black';
      let emailColor = 'black';
      let comIdNumColor = 'black';
      let phoneColor = 'black';
      let groupIdxColor = 'black';
      let activeStatusColor = 'black';

      if (value === 'fail') {
        statusColor = colorRed;
        delStatusColor = colorRed;

        if (cellName && cellName.length > 0) {
          if (cellName.indexOf('signId') >= 0) {
            signIdColor = colorRed;
          }
          if (cellName.indexOf('name') >= 0) {
            nameColor = colorRed;
          }
          if (cellName.indexOf('orgCode') >= 0) {
            orgCodeColor = colorRed;
          }
          if (cellName.indexOf('email') >= 0) {
            emailColor = colorRed;
          }
          if (cellName.indexOf('comIdNum') >= 0) {
            comIdNumColor = colorRed;
          }
          if (cellName.indexOf('phone') >= 0) {
            phoneColor = colorRed;
          }
          if (cellName.indexOf('groupIdx') >= 0) {
            groupIdxColor = colorRed;
          }
          if (cellName.indexOf('activeStatus') >= 0) {
            activeStatusColor = colorRed;
          }
        }
      }

      if (method === 'del') {
        if (cellName && cellName.length > 0) {
          statusColor = colorRed;
          if (cellName.indexOf('signId') >= 0) {
            signIdColor = colorRed;
          }
          if (cellName.indexOf('email') >= 0) {
            emailColor = colorRed;
          }
          if (cellName.indexOf('comIdNum') >= 0) {
            comIdNumColor = colorRed;
          }
          if (cellName.indexOf('phone') >= 0) {
            phoneColor = colorRed;
          }
        }
      }

      const data = [
        { data: item.signid, color: signIdColor },
        { data: item.name, color: nameColor },
        { data: item.email, color: emailColor },
        { data: cm.phoneFormat(item.phone), color: phoneColor }
      ];

      if (method === 'upd') {
        data.splice(2, 0, { data: item.activeStatus, color: activeStatusColor });
        data.splice(3, 0, { data: item.groupName, color: groupIdxColor });
      }
      if (method === 'reg' || method === 'upd') {
        data.push({ data: item.rankposition, color: signIdColor });
        data.push({ data: item.position, color: signIdColor });
      }
      data.push({ data: item.comidnum, color: comIdNumColor });
      if (step === 2) {
        data.unshift({
          data: item.status.text,
          color: method === 'del' ? delStatusColor : statusColor
        });
        data.push({ tooltip: item.status.cause, data: item.status.cause, color: statusColor });
        result = cm.tableStaffDivisionSet(data, 3, null, 'maxDepth', item.fullDivision);
      } else if (step >= 3) {
        result = cm.tableStaffDivisionSet(data, 2, item.orgCode, 'maxDepth', item.fullDivision);
      }

      return result;
    }
    return null;
  };

  handleInfiniteLoad = () => {
    const { tableResult, activeStep } = this.props.StaffExcelFn;
    const { elements, heightIdx, containerHeight } = this.state;
    const item = tableResult && tableResult.data ? tableResult.data.user : null;

    const that = this;
    const elemLength = elements.length;
    const itemLength = item ? item.length : 0;
    const infiniteParm = scroll.event(item, elements, containerHeight, heightIdx, elemLength);

    if (elemLength < itemLength) {
      const data = this.buildElements(elemLength, elemLength + 100, tableResult.data.user, false, activeStep);
      this.setState({
        isInfiniteLoading: true,
        heightIdx: heightIdx + containerHeight
      });

      setTimeout(() => {
        that.setState({
          elements: that.state.elements.concat(data),
          heightIdx: infiniteParm.heightIdx,
          isInfiniteLoading: false
        });
      }, 500);
    } else {
      this.setState({
        isInfiniteLoading: false
      });
    }
  };

  elementInfiniteLoad = () => <LoadingBar />;

  render() {
    const { activeStep, method, tableResult } = this.props.StaffExcelFn;
    // { list } = this.props,
    const { elements, isInfiniteLoading, heightIdx, containerHeight } = this.state;

    let total = 0;
    let success = 0;
    let fail = 0;
    let none = 0;
    let countSubText = '';

    if (tableResult && tableResult.data) {
      const { count } = tableResult.data;
      total = count.total;
      success = count.success;
      fail = count.fail;
      none = count.none;

      if (activeStep === 3) {
        if (method === 'reg') {
          countSubText = `총 ${total}명 신규 사용자 추가 예정`;
        } else if (method === 'upd') {
          countSubText = `총 ${success}명 수정 예정`;
        } else if (method === 'del') {
          countSubText = `총 ${total}명 퇴사처리 예정`;
        }
      } else if (activeStep === 4 && method !== 'reg') {
        countSubText = `총 ${total}명`;
      }
    }

    let title = '';
    let reason = '실패사유';
    if (method === 'reg') {
      title = '신규 사용자 추가';
    } else if (method === 'upd') {
      title = '사용자 정보 수정';
    } else if (method === 'del') {
      title = '사용자 퇴사 처리';
      reason = '사유';
    }

    let header = [
      { header: 'ID', width: 130, changeColor: true },
      { header: '이름', width: 120, changeColor: true },
      { header: '이메일', width: 180, changeColor: true },
      { header: '휴대전화번호', width: 133, changeColor: true }
    ];

    let tooltipStartNum = 2;
    let tooltipArray = cm.tooltipHeader(tooltipStartNum, null);
    let isNotTooltipItem = 6;
    if (method === 'upd') {
      header.splice(2, 0, { header: '활성상태', width: 180, changeColor: true });
      header.splice(3, 0, { header: '식대그룹', width: 120, changeColor: true });
    }
    if (method === 'reg' || method === 'upd') {
      isNotTooltipItem = 10;
      header.push({ header: '직위', width: 120, changeColor: true }, { header: '직책', width: 120, changeColor: true });
    }
    header.push({ header: '사원번호', width: 128, changeColor: true });
    if (activeStep === 2) {
      tooltipStartNum = 3;
      header.unshift({ header: '상태', width: 130, changeColor: true });
      header.push({ header: reason, width: 180, changeColor: true, style: { whiteSpace: 'pre-wrap' } });
      tooltipArray = cm.tooltipHeader(tooltipStartNum, [isNotTooltipItem]);
    } else if (activeStep === 3) {
      tooltipArray = cm.tooltipHeader(tooltipStartNum, null);
    }
    header = cm.tableHeaderList(header, tooltipStartNum, true, 'maxDepth');

    const columns = scroll.header(header, null, tooltipArray);
    return (
      <div className="staff-list">
        {activeStep === 4 ? (
          <div className="success-title">{title} 진행 중</div>
        ) : (
          <div className="sub-title">{title} 예정 목록</div>
        )}

        <div className="upload-table">
          {activeStep === 2 ? (
            <div className="count-box">
              총 ({total}) : 성공({success}) {method === 'upd' ? <span>/ 변경없음({none})</span> : ''} / 실패({fail})
            </div>
          ) : (
            ''
          )}
          {activeStep === 3 ? <div className="count-box">{countSubText}</div> : ''}
          {activeStep === 4 ? (
            <Fragment>
              <ul className="excel-upload-info">
                <li className="excel-upload-info-item">
                  엑셀로 사용자 정보를 업데이트 하는 요청은 시스템 상황에 따라 실시간으로 반영되지 않을 수 있습니다.
                </li>
                <li className="excel-upload-info-item">
                  <font color="red">
                    <b>약 10분 후에도 반영이 안되어 있다면,</b>
                  </font>{' '}
                  식권대장에 문의 바랍니다.
                </li>
              </ul>
              {method === 'reg' ? (
                <div className="count-box">
                  총 {total}명 최초 로그인 비밀번호: <span style={{ color: '#0bb656' }}>0000(숫자 0)</span>
                </div>
              ) : (
                <div className="count-box">{countSubText}</div>
              )}
            </Fragment>
          ) : (
            ''
          )}
          <InfiniteScroll
            elements={elements}
            isInfiniteLoading={isInfiniteLoading}
            heightIdx={heightIdx}
            columns={columns}
            containerHeight={containerHeight}
            elementInfiniteLoad={this.elementInfiniteLoad()}
            handleInfiniteLoad={this.handleInfiniteLoad}
            // resizable={false}
          />
        </div>
      </div>
    );
  }
}

ExcelStaffList = connect(
  (state) => ({
    list: state.company.staff_excel_check
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        // sikdaeGroupList : cm_action.SikdaeGroupList,
        // sikdaePolicySel : cm_action.SikdaePolicyList
      },
      dispatch
    )
  })
)(ExcelStaffList);

export default ExcelStaffList;
